import { Icon, IconProps } from ".";

export const Calendar = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M9.75 4V4.75V6H14.25V4.75V4H15.75V4.75V6H19V8.5V10V18.5V20H17.5H6.5H5V18.5V10V8.5V6H8.25V4.75V4H9.75ZM17.5 10H6.5V18.5H17.5V10ZM12 12V16H8V12H12Z" />
    </Icon>
  );
};
